import React from "react";
import { Grid, Box, Typography, FormControlLabel, Checkbox, CircularProgress } from "@mui/material";
import { CheckBox, CheckBoxOutlineBlank } from "@mui/icons-material";
import { StyledTextField } from "../../utilities/styles/checkoutPage.style";
import AddressAutocomplete from "../AddressAutocomplete";
import { replaceComma } from "../../services/HelperFunctions";

const AddressSelector = require("../../pages/checkout/AddressSelector").default;

interface DeliveryAddressSectionProps {
    selectedAddressId?: string;
    savedAddresses?: any[];
    addressName?: string;
    address1?: string;
    city?: string;
    stateProvince?: string;
    postalCode?: string;
    saveAddress: boolean;
    isLoggedIn: boolean;
    organizationSettings: any;
    classes: any;
    onStateChange: (updates: any) => void;
    onChange: (e: any, fieldName: string) => void;
}

const DeliveryAddressSection: React.FC<DeliveryAddressSectionProps> = ({
    selectedAddressId,
    savedAddresses,
    addressName,
    address1,
    city,
    stateProvince,
    postalCode,
    saveAddress,
    isLoggedIn,
    organizationSettings,
    classes,
    onStateChange,
    onChange,
}) => {
    return (
        <>
         <Typography
            sx={{
                mt: 4,
                mb: 2,
                fontSize: { sm: "20px" },
                fontWeight: 600,
            }}
            gutterBottom
        >
            Address
        </Typography>
            {selectedAddressId !== "" &&
                savedAddresses &&
                savedAddresses.length > 0 && (
                    <>
                    <Grid container spacing={2} direction="row">
                        <AddressSelector
                            selectedAddressId={selectedAddressId}
                            addresses={savedAddresses}
                            onAddressSelect={(addressId: any) => {
                                if (addressId === "new") {
                                    onStateChange({
                                        selectedAddressId: "",
                                        addressName: "",
                                        address1: "",
                                        city: "",
                                        stateProvince: "",
                                        postalCode: "",
                                    });
                                } else {
                                    const selectedAddress = savedAddresses.find(
                                        (address: any) => {
                                            return address.id === addressId;
                                        }
                                    );
                                    onStateChange({
                                        selectedAddressId: addressId,
                                        address1: replaceComma(selectedAddress?.address1),
                                        city: selectedAddress?.city,
                                        stateProvince: selectedAddress?.stateProvince,
                                        postalCode: selectedAddress?.postalCode,
                                    });
                                }
                            }}
                        />
                    </Grid>
                    </>
                )}

            {/* Hidden AddressAutocomplete for loading services */}
            <div style={{ visibility: "hidden", height: 0 }}>
                <AddressAutocomplete onPlaceSelect={(place: any) => { }} />
            </div>

            {((savedAddresses && savedAddresses.length === 0) ||
                selectedAddressId === "") && (
                    <Grid container spacing={2} direction="row">
                        <Grid item xs={12} sm={12}>
                            <AddressAutocomplete
                                onPlaceSelect={(place: any) => {
                                    onStateChange({
                                        addressName: place?.name,
                                        address1: replaceComma(place?.address),
                                        city: place?.city,
                                        county: place?.county,
                                        country: place?.country,
                                        postalCode: place?.postalCode,
                                        stateProvince: place?.state,
                                    });
                                }}
                                required
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <StyledTextField
                                name="city"
                                autoComplete="address-level2"
                                className={classes.marginBottom5}
                                required
                                id="city"
                                value={city}
                                onChange={(e: any) => onChange(e, "city")}
                                label="City"
                                variant="outlined"
                                fullWidth
                                type="text"
                                disabled
                            />
                        </Grid>
                        <Grid item xs={12} sm={2}>
                            <StyledTextField
                                name="stateProvince"
                                autoComplete="address-level1"
                                className={classes.marginBottom5}
                                required
                                id="stateProvince"
                                value={stateProvince}
                                onChange={(e: any) => onChange(e, "stateProvince")}
                                label="State"
                                variant="outlined"
                                fullWidth
                                type="text"
                                disabled
                            />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <StyledTextField
                                name="postalCode"
                                autoComplete="postal-code"
                                className={classes.marginBottom5}
                                id="postalCode"
                                value={postalCode}
                                onChange={(e: any) => onChange(e, "postalCode")}
                                placeholder="e.g. 10002"
                                label="Postal code"
                                variant="outlined"
                                fullWidth
                                type="text"
                                disabled
                            />
                        </Grid>
                        <Grid item xs={12} sm={12}>
                            <StyledTextField
                                name="addressName"
                                autoComplete="addressName"
                                className={classes.marginBottom5}
                                required={false}
                                id="addressName"
                                value={addressName}
                                onChange={(e: any) => onChange(e, "addressName")}
                                label="Address Name"
                                variant="outlined"
                                fullWidth
                                type="text"
                            />
                        </Grid>
                        {isLoggedIn && (
                            <Grid item xs={12} sm={4}>
                                <FormControlLabel
                                    label={
                                        <Typography
                                            sx={{
                                                p: {
                                                    fontSize: "16px !important",
                                                },
                                            }}
                                        >
                                            Save Address
                                        </Typography>
                                    }
                                    control={
                                        <Checkbox
                                            color="secondary"
                                            checked={saveAddress}
                                            size="small"
                                            icon={<CheckBoxOutlineBlank />}
                                            checkedIcon={<CheckBox />}
                                            onChange={(e) =>
                                                onStateChange({
                                                    saveAddress: e.target.checked,
                                                })
                                            }
                                        />
                                    }
                                />
                            </Grid>
                        )}
                    </Grid>
                )}
            {!savedAddresses && (
                <CircularProgress color="secondary" size={25} />
            )}
        </>
    );
};

export default DeliveryAddressSection;
